import React, { useEffect, useState, useRef } from 'react';
import './product.css';
import { BsHeart, BsPlus, BsHeartFill, BsShare } from "react-icons/bs";
import { BiMinus, BiLink } from 'react-icons/bi';
import { toast } from 'react-toastify';
import api from '../../api/api';
import * as newApi from "../../api/apiCollection";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loader from '../loader/Loader';
import { clearSelectedProduct, setSelectedProduct } from '../../model/reducer/selectedProduct';
import { addtoGuestCart, setCart, setCartProducts, setCartSubTotal, setSellerFlag, addGuestCartTotal, subGuestCartTotal } from '../../model/reducer/cartReducer';
import { setFavouriteLength, setFavouriteProductIds } from '../../model/reducer/favouriteReducer';
import Popup from '../same-seller-popup/Popup';
import useGetProductRatingsById from '../../hooks/useGetProductRatingsById';
import { OverlayTrigger, Popover, ProgressBar } from 'react-bootstrap';
import ProductDetailsTabs from './ProductDetailsTabs';
import StarFilledSVG from "../../utils/StarFilled.svg";
import useGetProductRatingImages from '../../hooks/useGetProductRatingImages';
import { LuStar } from 'react-icons/lu';
import VegIcon from "../../utils/Icons/VegIcon.svg";
import NonVegIcon from "../../utils/Icons/NonVegIcon.svg";
import NonCancelable from "../../utils/Icons/NotCancelable.svg";
import Cancelable from "../../utils/Icons/Cancelable.svg";
import Returnable from "../../utils/Icons/Returnable.svg";
import NotReturnable from "../../utils/Icons/NotReturnable.svg";
import { ValidateNoInternet } from '../../utils/NoInternetValidator';
import { MdSignalWifiConnectedNoInternet0 } from 'react-icons/md';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import { Navigation, Thumbs, Mousewheel, Autoplay, Pagination } from "swiper/modules";
import 'swiper/css/pagination';
import { AiOutlineEye } from 'react-icons/ai';
import { IoIosArrowDown } from "react-icons/io";
import ProductCard from './ProductCard';
import ProductImageZoom from './ProductImageZoom';
import { FaGift, FaClock, FaTag, FaHeart, FaShare, FaPlus, FaMinus, FaShoppingCart } from 'react-icons/fa';
import { HiOutlineHeart, HiOutlineShare, HiOutlinePlus, HiOutlineMinus } from 'react-icons/hi';
import { MdFavorite, MdFavoriteBorder, MdShare, MdAdd, MdRemove, MdShoppingCart } from 'react-icons/md';
import { Rate } from 'antd';
import { StarFilled, StarOutlined } from '@ant-design/icons';

const ProductDetails = () => {
    // Component for displaying product details with color-based image handling
    // Images structure: { "#1e4ba4": ["url1", "url2"], "#000000": ["url3"] }
    // Each color contains an array of images specific to that color
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { slug } = useParams();
    const location = useLocation();
    const product = useSelector(state => state.selectedProduct);
    const cart = useSelector(state => state.cart);
    const city = useSelector(state => state.city);
    const setting = useSelector(state => state.setting);
    const favorite = useSelector(state => (state.favourite));
    const shop = useSelector(state => state.shop);
    const user = useSelector(state => state.user);
    const { t } = useTranslation();

    // State variables
    const [productdata, setproductdata] = useState({});
    const [selectedVariant, setSelectedVariant] = useState(null);
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [discountCountdown, setDiscountCountdown] = useState(null);
    const [loading, setisLoading] = useState(false);
    const [cartLoader, setCartLoader] = useState(false);
    const [isNetworkError, setIsNetworkError] = useState(false);
    const [limit, setLimit] = useState(12);
    const [offset, setOffset] = useState(0);
    const [similarProducts, setSimilarProducts] = useState([]);
    const [similarProductsLength, setSimilarProductsLength] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [p_id, setP_id] = useState(0);
    const [p_v_id, setP_V_id] = useState(0);
    const [qnty, setQnty] = useState(0);
    const [isZoomed, setIsZoomed] = useState(false);
    const imageWrapperRef = useRef(null);

    const productLimit = 10;

    // Helper functions
    const getVariantColors = (variant) => {
        try {
            if (!variant?.colors) return [];
            const colors = JSON.parse(variant.colors);
            return Array.isArray(colors) ? colors : [];
        } catch (error) {
            return [];
        }
    };

    const getVariantSizes = (variant) => {
        try {
            if (!variant?.size) return [];
            const sizes = JSON.parse(variant.size);
            return Array.isArray(sizes) ? sizes : [];
        } catch (error) {
            return [];
        }
    };

    const hasColorImages = (variant, color) => {
        return variant?.images && 
               variant.images[color] && 
               Array.isArray(variant.images[color]) && 
               variant.images[color].length > 0 &&
               variant.images[color].some(img => img && img.trim() !== '');
    };

    const getVariantImages = (variant) => {
        if (!variant?.images) return [];
        
        // Handle the new images structure where each color has an array of images
        // Flatten all images from all colors into a single array
        const allImages = [];
        Object.values(variant.images).forEach(colorImages => {
            if (Array.isArray(colorImages)) {
                allImages.push(...colorImages);
            }
        });
        
        return allImages;
    };

    const getCurrentVariantImages = () => {
        if (!selectedVariant) return [];
        
        // If we have a selected color, check if it has specific images
        if (selectedColor) {
            if (hasColorImages(selectedVariant, selectedColor)) {
                // If color has specific images, return them
                return selectedVariant.images[selectedColor];
            } else {
                // If color doesn't have specific images, return only the main image_url
                // This ensures we don't show other color images when a specific color is selected
                return selectedVariant.image_url ? [selectedVariant.image_url] : [];
            }
        }
        
        // If no color selected, get all variant images
        const images = getVariantImages(selectedVariant);
        if (images.length > 0) {
            return images;
        }
        
        // Fallback to variant image
        return selectedVariant.image_url ? [selectedVariant.image_url] : [];
    };

    const hasFreeQuantityOffer = (variant) => {
        return variant?.free_quantity && variant?.free_quantity > 0;
    };

    const calculateDiscount = (discountedPrice, originalPrice) => {
        if (!discountedPrice || discountedPrice === 0) return 0;
        const difference = originalPrice - discountedPrice;
        return Math.round((difference / originalPrice) * 100);
    };

    // API functions
    const getProductDatafromApi = (slug) => {
        if (!slug) return;
        
        api.getProductbyId(
            city.city?.latitude ? city.city?.latitude : setting?.setting?.default_city?.latitude,
            city.city?.longitude ? city.city?.longitude : setting?.setting?.default_city?.longitude,
            -1, user?.jwtToken, slug
        )
                .then(response => response.json())
                .then(result => {
                    if (result.status === 1) {
                const filter = { limit: productLimit, offset };
                api.getProductbyFilter(
                    city.city?.latitude ? city.city?.latitude : setting?.setting?.default_city?.latitude,
                    city.city?.longitude ? city.city?.longitude : setting?.setting?.default_city?.longitude,
                    filter, user?.jwtToken, result?.data?.tag_names, slug
                ).then((res) => res.json()).then((result => {
                    setSimilarProducts(result?.data);
                    setSimilarProductsLength(result.total);
                }));

                        dispatch(setSelectedProduct({ data: result?.data[0]?.id }));
                        setproductdata(result.data);
                
                // Set initial variant
                const initialVariant = result.data.variants?.[0];
                setSelectedVariant(initialVariant);
                
                // Set initial color if available
                if (initialVariant) {
                    const colors = getVariantColors(initialVariant);
                    if (colors.length > 0) {
                        setSelectedColor(colors[0]);
                    }
                }
            }
                })
                .catch(error => {
                    console.log(error);
                    const isNoInternet = ValidateNoInternet(error);
                    if (isNoInternet) {
                        setIsNetworkError(isNoInternet);
                    }
                });
    };

    // Cart functions - Updated with improved logic from ProductCard.jsx
    const isProductInCart = (
        (cart?.isGuest === false && 
            cart?.cartProducts?.find((prdct) => 
                prdct?.product_variant_id === selectedVariant?.id &&
                prdct?.selected_color === selectedColor &&
                prdct?.selected_size === selectedSize
            )?.qty > 0) ||
        (cart?.isGuest === true && 
            cart?.guestCart?.find((prdct) => 
                prdct?.product_variant_id === selectedVariant?.id &&
                prdct?.selected_color === selectedColor &&
                prdct?.selected_size === selectedSize
            )?.qty > 0)
    );

    const cartQuantity = cart?.isGuest === false
        ? cart?.cartProducts?.find(prdct => 
            prdct?.product_variant_id === selectedVariant?.id &&
            prdct?.selected_color === selectedColor &&
            prdct?.selected_size === selectedSize
          )?.qty || 0
        : cart?.guestCart?.find(prdct => 
            prdct?.product_variant_id === selectedVariant?.id &&
            prdct?.selected_color === selectedColor &&
            prdct?.selected_size === selectedSize
          )?.qty || 0;

    // Updated cart operations using new API structure
    const addtoCart = async (productId, productVId, qty) => {
        setCartLoader(true);
        try {
            const response = await newApi.addToCart({ 
                product_id: productId, 
                product_variant_id: productVId, 
                qty: qty,
                selected_color: selectedColor,
                selected_size: selectedSize
            });
            
            if (response.status === 1) {
                const existingProduct = cart?.cartProducts?.find((product) => 
                    product?.product_id == productId && 
                    product?.product_variant_id == productVId &&
                    product?.selected_color === selectedColor &&
                    product?.selected_size === selectedSize
                );
                
                if (!existingProduct?.qty) {
                    // Add new product to cart
                    dispatch(setCart({ data: response }));
                    const updatedCartCount = [...cart?.cartProducts, { 
                        product_id: productId, 
                        product_variant_id: productVId, 
                        qty: qty,
                        selected_color: selectedColor,
                        selected_size: selectedSize 
                    }];
                    dispatch(setCartProducts({ data: updatedCartCount }));
                    dispatch(setCartSubTotal({ data: response?.sub_total }));
                } else {
                    // Update existing product quantity
                    const updatedProducts = cart?.cartProducts?.map(product => {
                        if (product.product_id == productId && product?.product_variant_id == productVId && product?.selected_color === selectedColor && product?.selected_size === selectedSize) {
                            return { 
                                ...product, 
                                qty: qty,
                                selected_color: selectedColor,
                                selected_size: selectedSize 
                            };
                        }
                        return product;
                    });
                    dispatch(setCart({ data: response }));
                    dispatch(setCartProducts({ data: updatedProducts }));
                    dispatch(setCartSubTotal({ data: response?.sub_total }));
                }
            } else if (response?.data?.one_seller_error_code == 1) {
                dispatch(setSellerFlag({ data: 1 }));
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.log("error", error);
            toast.error("حدث خطأ أثناء إضافة المنتج إلى السلة");
        }
        setCartLoader(false);
    };

    const removefromCart = async (productId, variantId) => {
        setisLoading(true);
        try {
            const response = await newApi.removeFromCart({ 
                product_id: productId, 
                product_variant_id: variantId,
                selected_color: selectedColor,
                selected_size: selectedSize
            });
            
            if (response?.status === 1) {
                const updatedProducts = cart?.cartProducts?.filter(product => {
                    // حذف المنتج المحدد فقط (نفس product_id, product_variant_id, selected_color, selected_size)
                    return !(product?.product_id === productId && 
                            product?.product_variant_id === variantId &&
                            product?.selected_color === selectedColor &&
                            product?.selected_size === selectedSize);
                });
                dispatch(setCartSubTotal({ data: response?.sub_total }));
                dispatch(setCartProducts({ data: updatedProducts }));
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.log("error", error);
            toast.error("حدث خطأ أثناء إزالة المنتج من السلة");
        }
        setisLoading(false);
    };

    // Guest cart operations
    const AddToGuestCart = (product, productId, productVariantId, Qty, isExisting, flag) => {
        const now = new Date();
        const startDate = selectedVariant?.discount_start_date ? new Date(selectedVariant.discount_start_date) : null;
        const endDate = selectedVariant?.discount_end_date ? new Date(selectedVariant.discount_end_date) : null;
        const isDiscountActive = selectedVariant?.discounted_price && 
                               selectedVariant?.discounted_price !== 0 && 
                               selectedVariant?.discounted_price < selectedVariant?.price &&
                               startDate && endDate &&
                               now >= startDate && now <= endDate;
        const finalPrice = isDiscountActive ? selectedVariant?.discounted_price : selectedVariant?.price;
        
        if (isExisting) {
            let updatedProducts;
            if (Qty !== 0) {
                if (flag == "add") {
                    dispatch(addGuestCartTotal({ data: finalPrice }));
                } else if (flag == "remove") {
                    dispatch(subGuestCartTotal({ data: finalPrice }));
                }
                updatedProducts = cart?.guestCart?.map((product) => {
                    if (product?.product_id == productId && product?.product_variant_id == productVariantId) {
                        return { 
                            ...product, 
                            qty: Qty,
                            selected_color: selectedColor,
                            selected_size: selectedSize
                        };
                    }
                    return product;
                });
            } else {
                if (flag == "add") {
                    dispatch(addGuestCartTotal({ data: finalPrice }));
                } else if (flag == "remove") {
                    dispatch(subGuestCartTotal({ data: finalPrice }));
                }
                updatedProducts = cart?.guestCart?.filter(product =>
                    product?.product_id != productId && product?.product_variant_id != productVariantId
                );
            }
            dispatch(addtoGuestCart({ data: updatedProducts }));
        } else {
            if (flag == "add") {
                dispatch(addGuestCartTotal({ data: finalPrice }));
            } else if (flag == "remove") {
                dispatch(subGuestCartTotal({ data: finalPrice }));
            }
            const productData = { 
                product_id: productId, 
                product_variant_id: productVariantId, 
                qty: Qty,
                selected_color: selectedColor,
                selected_size: selectedSize
            };
            dispatch(addtoGuestCart({ data: [...cart?.guestCart, productData] }));
        }
    };

    // Favorite functions - Updated with new API structure
    const addToFavorite = async (product_id) => {
        try {
            if (user?.jwtToken) {
                const res = await newApi.addToFavorite({ product_id: product_id });
                if (res.status == 1) {
                    toast.success(res.message);
                    const updatedFavouriteProducts = [...favorite.favouriteProductIds, product_id];
                    dispatch(setFavouriteProductIds({ data: updatedFavouriteProducts }));
                    const updatedFavouriteLength = favorite?.favouritelength + 1;
                    dispatch(setFavouriteLength({ data: updatedFavouriteLength }));
                } else {
                    toast.error(res.message);
                }
            } else {
                toast.error(t("required_login_message_for_wishlist"));
            }
        } catch (error) {
            console.log(error);
            toast.error("حدث خطأ أثناء إضافة المنتج للمفضلة");
        }
    };

    const removefromFavorite = async (product_id) => {
        try {
            if (user?.jwtToken) {
                const res = await newApi.removeFromFavorite({ product_id: product_id });
                if (res.status == 1) {
                    toast.success(res.message);
                    const updatedFavouriteProducts = favorite?.favouriteProductIds.filter(id => id != product_id);
                    dispatch(setFavouriteProductIds({ data: updatedFavouriteProducts }));
                    const updatedFavouriteLength = favorite?.favouritelength - 1;
                    dispatch(setFavouriteLength({ data: updatedFavouriteLength }));
                } else {
                    toast.error(res.message);
                }
            } else {
                toast.error(t("required_login_message_for_wishlist"));
            }
        } catch (error) {
            console.log(error);
            toast.error("حدث خطأ أثناء إزالة المنتج من المفضلة");
        }
    };

    // Variant and color handlers
    const handleVariantChange = (variant) => {
        setSelectedVariant(variant);
        setCurrentImageIndex(0);
        
        // Reset color and size for new variant
        const colors = getVariantColors(variant);
        if (colors.length > 0) {
            setSelectedColor(colors[0]);
        } else {
            setSelectedColor(null);
        }
        
        const sizes = getVariantSizes(variant);
        if (sizes.length > 0) {
            setSelectedSize(sizes[0]);
        } else {
            setSelectedSize(null);
        }
        
        // The images will be updated automatically through getCurrentVariantImages
        // when the component re-renders with the new selectedVariant and selectedColor
    };

    const handleColorChange = (color) => {
        setSelectedColor(color);
        setCurrentImageIndex(0);
        
        // The images will be updated automatically through getCurrentVariantImages
        // when the component re-renders with the new selectedColor
    };

    const handleSizeChange = (size) => {
        setSelectedSize(size);
    };

    // Cart quantity handlers
    // Utility functions - Updated with improved logic from ProductCard.jsx
    const getProductQuantities = (products) => {
        if (!products || !Array.isArray(products) || products.length === 0) {
            return [];
        }
        const quantities = products.reduce((acc, product) => {
            if (!product || typeof product !== 'object') {
                return acc;
            }
            const productId = product.product_id;
            if (!productId) {
                return acc;
            }
            const existingQty = acc[productId] || 0;
            const qty = product.qty || 0;
            return { ...acc, [productId]: existingQty + qty };
        }, {});
        
        return Object.entries(quantities).map(([productId, qty]) => ({
            product_id: parseInt(productId),
            qty
        }));
    };

    // Cart validation and handling - Updated with improved logic from ProductCard.jsx
    const handleValidateAddNewProduct = (productQuantity, product) => {
        const productQty = productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty;

        if ((productQty || 0) >= Number(product?.total_allowed_quantity)) {
            toast.error('Oops, Limited Stock Available');
        } else if (Number(product.is_unlimited_stock)) {
            addtoCart(product.id, selectedVariant.id, 1);
        } else {
            if (selectedVariant?.status) {
                addtoCart(product.id, selectedVariant?.id, 1);
            } else {
                toast.error('Oops, Limited Stock Available');
            }
        }
    };

    const handleValidateAddExistingProduct = (productQuantity, product) => {
        const productQty = productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty;
        if (Number(product.is_unlimited_stock)) {
            if (productQty < Number(product?.total_allowed_quantity)) {
                addtoCart(product.id, selectedVariant?.id, cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant?.id)?.qty + 1);
            } else {
                toast.error('Apologies, maximum product quantity limit reached!');
            }
        } else {
            if (productQty >= Number(selectedVariant.stock)) {
                toast.error(t("out_of_stock_message"));
            } else if (Number(productQty) >= Number(product.total_allowed_quantity)) {
                toast.error('Apologies, maximum product quantity limit reached');
            } else {
                addtoCart(product.id, selectedVariant?.id, cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant?.id)?.qty + 1);
            }
        }
    };

    const handleAddNewProductGuest = (productQuantity, product) => {
        const productQty = productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty;
        if (selectedVariant?.is_unlimited_stock == 0 && selectedVariant?.stock == 0) {
            toast.error(t("out_of_stock_message"));
        } else if (Number(productQty || 0) < Number(product.total_allowed_quantity)) {
            AddToGuestCart(product, product.id, selectedVariant?.id, 1, 0, "add");
        } else {
            toast.error(t("out_of_stock_message"));
        }
    };

    const handleValidateAddExistingGuestProduct = (productQuantity, product, quantity) => {
        const productQty = productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty;

        if (Number(product.is_unlimited_stock !== 0)) {
            if (productQty >= Number(product?.total_allowed_quantity)) {
                toast.error('Apologies, maximum product quantity limit reached');
            } else {
                AddToGuestCart(product, product?.id, selectedVariant?.id, quantity, 1, "add");
            }
        } else {
            if (productQty >= Number(selectedVariant?.stock)) {
                toast.error('Oops, Limited Stock Available');
            } else if (productQty >= Number(product?.total_allowed_quantity)) {
                toast.error('Apologies, maximum cart quantity limit reached');
            } else {
                AddToGuestCart(product, product?.id, selectedVariant?.id, quantity, 1, "add");
            }
        }
    };

    // Quantity controls - Updated with improved logic from ProductCard.jsx
    const handleQuantityDecrease = () => {
        if (cart?.isGuest) {
            AddToGuestCart(
                productdata,
                productdata?.id,
                selectedVariant?.id,
                cart?.guestCart?.find((prdct) => prdct?.product_variant_id == selectedVariant?.id)?.qty - 1,
                1,
                "remove"
            );
        } else {
            if (cart?.cartProducts?.find((prdct) => prdct?.product_variant_id == selectedVariant?.id)?.qty == 1) {
                removefromCart(productdata?.id, selectedVariant?.id);
            } else {
                addtoCart(productdata.id, selectedVariant.id, cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant?.id)?.qty - 1);
            }
        }
    };

    const handleQuantityIncrease = () => {
        if (!cart) return;
        
        if (cart.isGuest) {
            const guestCart = cart.guestCart || [];
            const productQuantity = getProductQuantities(guestCart);
            const existingProduct = guestCart.find(prdct => 
                prdct?.product_id === productdata?.id && 
                prdct?.product_variant_id === selectedVariant?.id
            );
            const newQty = (existingProduct?.qty || 0) + 1;
            
            handleValidateAddExistingGuestProduct(
                productQuantity,
                productdata,
                newQty
            );
        } else {
            const cartProducts = cart.cartProducts || [];
            const quantity = getProductQuantities(cartProducts);
            handleValidateAddExistingProduct(quantity, productdata);
        }
    };

    // Enhanced Zoom Functions
    const handleImageMouseEnter = () => {
        setIsZoomed(true);
        // Ensure smooth transition
        const img = imageWrapperRef.current?.querySelector('.main-product-image');
        if (img) {
            img.style.transition = 'transform 0.1s ease';
        }
    };

    const handleImageMouseLeave = () => {
        setIsZoomed(false);
        // Reset image transform when mouse leaves
        const img = imageWrapperRef.current?.querySelector('.main-product-image');
        if (img) {
            img.style.transition = 'transform 0.3s ease';
            img.style.transform = 'scale(1)';
            img.style.transformOrigin = 'center center';
        }
    };

    const handleImageMouseMove = (e) => {
        if (!isZoomed || !imageWrapperRef.current) return;
        
        const rect = imageWrapperRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;
        
        const img = imageWrapperRef.current.querySelector('.main-product-image');
        if (img) {
            img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
            img.style.transform = `scale(3.5)`;
        }
    };

    const handleInitialAddToCart = () => {
        if (!cart) return;
        
        if (cart.isGuest) {
            const cartProducts = cart.cartProducts || [];
            const quantity = getProductQuantities(cartProducts);
            handleAddNewProductGuest(quantity, productdata);
        } else {
            if (user?.user === null) {
                return toast.error(t("required_login_message_for_cart"));
            }
            const cartProducts = cart.cartProducts || [];
            const quantity = getProductQuantities(cartProducts);
            handleValidateAddNewProduct(quantity, productdata);
        }
    };

    // Discount countdown effect
    useEffect(() => {
        if (!selectedVariant) return;
        
        if (selectedVariant?.discounted_price && selectedVariant?.discounted_price < selectedVariant?.price) {
            const now = new Date();
            const startDate = new Date(selectedVariant.discount_start_date);
            const endDate = new Date(selectedVariant.discount_end_date);

            if (now >= startDate && now <= endDate) {
                const interval = setInterval(() => {
                    const remaining = endDate - new Date();
                    if (remaining <= 0) {
                        clearInterval(interval);
                        setDiscountCountdown(null);
        } else {
                        const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
                        const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
                        const minutes = Math.floor((remaining / (1000 * 60)) % 60);
                        const seconds = Math.floor((remaining / 1000) % 60);
                        setDiscountCountdown(`${days} يوم ${hours} ساعة ${minutes} دقيقة ${seconds} ثانية`);
                    }
                }, 1000);

                return () => clearInterval(interval);
            } else {
                setDiscountCountdown(null);
            }
        } else {
            setDiscountCountdown(null);
        }
    }, [selectedVariant]);

    // Effects
    useEffect(() => {
        window.scrollTo({ top: 0 });
        return () => {
            dispatch(clearSelectedProduct({ data: null }));
        };
    }, []);

    useEffect(() => {
        if (slug) {
            getProductDatafromApi(slug);
        }
    }, [slug, setting]);

    const { productRating, totalData, loading: Loading, error } = useGetProductRatingsById(user?.jwtToken, productdata?.id, limit, offset);
    const { ratingImages, totalImages } = useGetProductRatingImages(user?.jwtToken, productdata?.id, 8, offset);

    // Computed values
    const isProductAvailable = selectedVariant && (
        selectedVariant.status === 1 && 
        (selectedVariant.is_unlimited_stock === 1 || selectedVariant.stock > 0)
    );

    const currentImages = getCurrentVariantImages();
    const currentImage = currentImages[currentImageIndex] || selectedVariant?.image_url || productdata?.image_url;

    return (
        <>
            {loading && <Loader screen="full" background="none" />}
            {!isNetworkError ? (
                <div className="modern-product-details">
                    {/* Breadcrumb */}
                    <div className="breadcrumb-container">
                        <div className="container">
                            <nav className="breadcrumb-nav">
                                <Link to="/" className="breadcrumb-item">{t("home")}</Link>
                                <span className="breadcrumb-separator">/</span>
                                <span className="breadcrumb-item active">{productdata?.name}</span>
                            </nav>
                            </div>
                            </div>

                    <div className="container">
                        {Object.keys(productdata || {}).length === 0 ? (
                            <Loader width="100%" height="600px" background="var(--second-cards-color)" />
                        ) : (
                            <div className="product-details-grid">
                                {/* Product Images Section */}
                                <div className="product-images-section">
                                    <div className="main-image-container">
                                        <div 
                                            className={`main-image-wrapper ${isZoomed ? 'zoomed' : ''}`}
                                            ref={imageWrapperRef}
                                            onMouseEnter={handleImageMouseEnter}
                                            onMouseLeave={handleImageMouseLeave}
                                            onMouseMove={handleImageMouseMove}
                                        >
                                            <img 
                                                src={currentImage} 
                                                alt={productdata.name}
                                                className="main-product-image"
                                                onError={(e) => {
                                                    e.target.src = setting.setting?.web_logo;
                                                }}
                                            />
                                            
                                            {/* Zoom Indicator */}
                                            
                                            
                                            {/* Image Counter */}
                                            {currentImages.length > 1 && (
                                                <div className="image-counter">
                                                    {currentImageIndex + 1} / {currentImages.length}
                    </div>
                                            )}
                                            
                                            {/* Image Navigation */}
                                            {currentImages.length > 1 && (
                                                <div className="image-navigation">
                                                    <button 
                                                        className="nav-btn"
                                                        onClick={() => setCurrentImageIndex(prev => prev > 0 ? prev - 1 : currentImages.length - 1)}
                                                        disabled={currentImages.length <= 1}
                                                    >
                                                        ‹
                                                    </button>
                                                    <button 
                                                        className="nav-btn"
                                                        onClick={() => setCurrentImageIndex(prev => prev < currentImages.length - 1 ? prev + 1 : 0)}
                                                        disabled={currentImages.length <= 1}
                                                    >
                                                        ›
                                                    </button>
                                                </div>
                                            )}
                                            
                                            {/* Discount Badge */}
                                            {(() => {
                                                const now = new Date();
                                                const startDate = selectedVariant?.discount_start_date ? new Date(selectedVariant.discount_start_date) : null;
                                                const endDate = selectedVariant?.discount_end_date ? new Date(selectedVariant.discount_end_date) : null;
                                                const isDiscountActive = selectedVariant?.discounted_price && 
                                                                       selectedVariant?.discounted_price > 0 && 
                                                                       selectedVariant?.discounted_price < selectedVariant?.price &&
                                                                       startDate && endDate &&
                                                                       now >= startDate && now <= endDate;

                                                if (isDiscountActive) {
                                                    return (
                                                        <div className="discount-badge">
                                                            <FaTag />
                                                            <span>{calculateDiscount(selectedVariant.discounted_price, selectedVariant.price)}%</span>
                                                        </div>
                                                    );
                                                }
                                                return null;
                                            })()}

                                            {/* Free Quantity Badge */}
                                            {hasFreeQuantityOffer(selectedVariant) && (
                                                <div className="free-quantity-badge">
                                                    <FaGift />
                                                    <span>{selectedVariant.free_quantity} مجاني</span>
                                                                        </div>
                                            )}

                                            {/* Discount Countdown */}
                                            {discountCountdown && (
                                                <div className="discount-countdown-badge">
                                                    <FaClock />
                                                    <span>{discountCountdown}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Thumbnail Images */}
                                    {currentImages.length > 1 && (
                                        <div className="thumbnail-images">
                                            <h4 className="thumbnail-title">صور المنتج</h4>
                                            <Swiper
                                                spaceBetween={10}
                                                slidesPerView={4}
                                                navigation={true}
                                                modules={[Navigation]}
                                                className="thumbnail-swiper"
                                                breakpoints={{
                                                    320: { slidesPerView: 3 },
                                                    480: { slidesPerView: 4 },
                                                    768: { slidesPerView: 5 },
                                                    1024: { slidesPerView: 6 }
                                                }}
                                            >
                                                {currentImages.map((image, index) => (
    <SwiperSlide key={index}>
      <div 
                                                            className={`thumbnail-item ${currentImageIndex === index ? 'active' : ''}`}
                                                            onClick={() => setCurrentImageIndex(index)}
      >
        <img 
          src={image} 
                                                                alt={`${productdata.name} ${index + 1}`}
                                                                onError={(e) => {
                                                                    e.target.src = setting.setting?.web_logo;
          }}
        />
      </div>
    </SwiperSlide>
                                                ))}
                                                        </Swiper>
                                                                </div>
                                    )}
                                                </div>

                                {/* Product Info Section */}
                                <div className="product-info-section">
                                    {/* Product Header */}
                                    <div className="product-header">
                                        <h1 className="product-title">{productdata.name}</h1>
                                        <div className="product-meta-row">
                                            {productRating?.average_rating > 0 && (
                                                <div className="product-rating">
                                                    <Rate
                                                        disabled
                                                        defaultValue={productRating.average_rating}
                                                        allowHalf={true}
                                                        character={({ index }) => (
                                                            index < productRating.average_rating ? (
                                                                <StarFilled className="filled-star" />
                                                            ) : (
                                                                <StarOutlined className="empty-star" />
                                                            )
                                                        )}
                                                    />
                                                    <span className="rating-count">({totalData} تقييم)</span>
                                                        </div>
                                            )}
                                                                                        <div className="price-section">
                                                {(() => {
                                                    const now = new Date();
                                                    const startDate = selectedVariant?.discount_start_date ? new Date(selectedVariant.discount_start_date) : null;
                                                    const endDate = selectedVariant?.discount_end_date ? new Date(selectedVariant.discount_end_date) : null;
                                                    const isDiscountActive = selectedVariant?.discounted_price && 
                                                                           selectedVariant?.discounted_price > 0 && 
                                                                           selectedVariant?.discounted_price < selectedVariant?.price &&
                                                                           startDate && endDate &&
                                                                           now >= startDate && now <= endDate;

                                                    return (
                                                        <>
                                                            <span className="current-price price-saudi">
                                                                {setting.setting?.currency_symbol}
                                                                {isDiscountActive 
                                                                    ? selectedVariant.discounted_price.toFixed(setting.setting?.decimal_point || 2)
                                                                    : selectedVariant?.price?.toFixed(setting.setting?.decimal_point || 2)
                                                                }
                                                            </span>
                                                            
                                                            {isDiscountActive && (
                                                                <span className="original-price price-saudi">
                                                                    {setting.setting?.currency_symbol}
                                                                    {selectedVariant.price.toFixed(setting.setting?.decimal_point || 2)}
                                                                </span>
                                                            )}

                                                            {isDiscountActive && (
                                                                <span className="discount-percentage">
                                                                    خصم {calculateDiscount(selectedVariant.discounted_price, selectedVariant.price)}%
                                                                </span>
                                                            )}
                                                        </>
                                                    );
                                                })()}
                                            </div>
                                                    </div>
                                                </div>

                                    {/* Smart Variants and Options Layout */}
                                    <div className="product-options-grid">
                                        {/* Variants Section */}
                                        {productdata.variants?.length > 1 && (
                                            <div className="variants-section">
                                                <h3 className="section-title">الانواع المتوفرة</h3>
                                                <div className="variants-grid">
                                                    {productdata.variants.map((variant) => (
                                                        <button
                                                            key={variant.id}
                                                            className={`variant-option ${selectedVariant?.id === variant.id ? 'selected' : ''}`}
                                                            onClick={() => handleVariantChange(variant)}
                                                        >
                                                            <span className="variant-measurement">
                                                                {variant.measurement} {variant.stock_unit_name}
                                                            </span>
                                                            <span className="variant-price">
                                                                {setting.setting?.currency_symbol}
                                                                {(() => {
                                                                    const now = new Date();
                                                                    const startDate = variant?.discount_start_date ? new Date(variant.discount_start_date) : null;
                                                                    const endDate = variant?.discount_end_date ? new Date(variant.discount_end_date) : null;
                                                                    const isDiscountActive = variant?.discounted_price && 
                                                                                           variant?.discounted_price > 0 && 
                                                                                           variant?.discounted_price < variant?.price &&
                                                                                           startDate && endDate &&
                                                                                           now >= startDate && now <= endDate;

                                                                    return isDiscountActive ? variant.discounted_price : variant.price;
                                                                })()}
                                                            </span>
                                                        </button>
                                                    ))}
                                                                                    </div>
                                                                                    </div>
                                        )}

                                        {/* Colors Section */}
                                        {selectedVariant && getVariantColors(selectedVariant).length > 0 && (
                                            <div className="colors-section">
                                                <h3 className="section-title">الألوان المتاحة</h3>
                                                <div className="colors-grid">
                                                    {getVariantColors(selectedVariant).map((color, index) => (
                                                        <button
                                                            key={index}
                                                            className={`color-option ${selectedColor === color ? 'selected' : ''} ${hasColorImages(selectedVariant, color) ? 'has-images' : ''}`}
                                                            style={{ backgroundColor: color }}
                                                            onClick={() => handleColorChange(color)}
                                                            title={`${color}${hasColorImages(selectedVariant, color) ? ' - يحتوي على صور' : ''}`}
                                                        />
                                                    ))}
                                                                            </div>
                                                                        </div>
                                        )}
                                                            </div>

                                    {/* Sizes Section - Full Width */}
                                    {selectedVariant && getVariantSizes(selectedVariant).length > 0 && (
                                        <div className="sizes-section">
                                            <h3 className="section-title">المقاسات</h3>
                                            <div className="sizes-grid">
                                                {getVariantSizes(selectedVariant).map((size, index) => (
                                                                            <button
                                                        key={index}
                                                        className={`size-option ${selectedSize === size ? 'selected' : ''}`}
                                                        onClick={() => handleSizeChange(size)}
                                                    >
                                                        {size}
                                                                            </button>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Add to Cart Section */}
                                    <div className="add-to-cart-section">
                                        {!isProductAvailable ? (
                                            <div className="out-of-stock-message">
                                                {t("out_of_stock_message")}
                                            </div>
                                        ) : isProductInCart ? (
                                            <div className="quantity-controls">
                                                <button 
                                                    className="quantity-btn decrease"
                                                    onClick={handleQuantityDecrease}
                                                    disabled={cartLoader}
                                                >
                                                    <MdRemove />
                                                </button>
                                                <span className="quantity-display">
                                                    {cartLoader ? (
                                                        <div className="spinner-border spinner-border-sm" />
                                                    ) : (
                                                        cartQuantity
                                                    )}
                                                                            </span>
                                                                            <button
                                                    className="quantity-btn increase"
                                                    onClick={handleQuantityIncrease}
                                                    disabled={cartLoader}
                                                >
                                                    <MdAdd />
                                                                            </button>
                                                                        </div>
                                        ) : (
                                            <button
                                                className="add-to-cart-btn"
                                                onClick={handleInitialAddToCart}
                                                disabled={cartLoader}
                                            >
                                                {cartLoader ? (
                                                    <div className="spinner-border spinner-border-sm" />
                                                ) : (
                                                    <>
                                                        <MdShoppingCart />
                                                        {t("add_to_cart")}
                                                    </>
                                                )}
                                            </button>
                                        )}

                                        {/* Favorite Button */}
                                        <button
                                            className={`favorite-btn ${favorite?.favouriteProductIds?.includes(productdata.id) ? 'active' : ''}`}
                                                                            onClick={() => {
                                                if (user?.jwtToken) {
                                                    if (favorite?.favouriteProductIds?.includes(productdata.id)) {
                                                                        removefromFavorite(productdata.id);
                                                                    } else {
                                                                            addToFavorite(productdata.id);
                                                    }
                                                                        } else {
                                                                            toast.error(t("required_login_message_for_wishlist"));
                                                                        }
                                            }}
                                        >
                                            {favorite?.favouriteProductIds?.includes(productdata.id) ? (
                                                <MdFavorite />
                                            ) : (
                                                <MdFavoriteBorder />
                                            )}
                                        </button>
                                                        </div>

                                    {/* Product Info Details */}
                                    {selectedVariant && (
                                        <div className="product-info-details">
                                            <div className="info-item">
                                                <span className="info-label">المقاس:</span>
                                                <span className="info-value">
                                                    {selectedVariant.measurement} {selectedVariant.stock_unit_name}
                                                                </span>
                                                            </div>
                                            
                                            {selectedColor && (
                                                <div className="info-item">
                                                    <span className="info-label">اللون المختار:</span>
                                                    <div className="selected-color-display">
                                                        <div 
                                                            className="color-preview" 
                                                            style={{ backgroundColor: selectedColor }}
                                                        ></div>
                                                        <span>{selectedColor}</span>
                                                        </div>
                                                            </div>
                                            )}
                                            
                                            {selectedSize && (
                                                <div className="info-item">
                                                    <span className="info-label">المقاس المختار:</span>
                                                    <span className="info-value">{selectedSize}</span>
                                                </div>
                                            )}

                                            {selectedVariant?.stock !== undefined && (
                                                <div className="info-item">
                                                    <span className="info-label">المخزون المتاح:</span>
                                                    <span className={`info-value ${selectedVariant.stock > 0 ? 'in-stock' : 'out-of-stock'}`}>
                                                        {selectedVariant.is_unlimited_stock === 1 ? 'غير محدود' : selectedVariant.stock}
                                                                    </span>
                                                                </div>
                                            )}

                                            {hasFreeQuantityOffer(selectedVariant) && (
                                                <div className="info-item free-offer">
                                                    <span className="info-label">العرض المجاني:</span>
                                                    <span className="info-value">
                                                        {selectedVariant.free_quantity} {selectedVariant.stock_unit_name} مجاني
                                                            </span>
                                                        </div>
                                            )}
                                                        </div>
                                    )}

                                    {/* Share Section */}
                                    <div className="share-section">
                                        <span className="share-label">مشاركة المنتج:</span>
                                        <div className="share-buttons">
                                            <button 
                                                className="share-btn whatsapp"
                                                onClick={() => {
                                                    const url = `${setting.setting?.web_settings?.website_url || window.location.origin}/product/${productdata.slug}`;
                                                    window.open(`https://wa.me/?text=${encodeURIComponent(`تحقق من هذا المنتج: ${url}`)}`, '_blank');
                                                }}
                                            >
                                                <MdShare />
                                            </button>
                                            <button 
                                                className="share-btn facebook"
                                                onClick={() => {
                                                    const url = `${setting.setting?.web_settings?.website_url || window.location.origin}/product/${productdata.slug}`;
                                                    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
                                                }}
                                            >
                                                <MdShare />
                                            </button>
                                            <button 
                                                className="share-btn copy-link"
                                                onClick={() => {
                                                    const url = `${setting.setting?.web_settings?.website_url || window.location.origin}/product/${productdata.slug}`;
                                                    navigator.clipboard.writeText(url);
                                                    toast.success("تم نسخ الرابط بنجاح!");
                                                }}
                                            >
                                                <MdShare />
                                            </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                        {/* Product Tabs */}
                        <ProductDetailsTabs
                            productdata={productdata}
                            productRating={productRating}
                            totalData={totalData}
                            loading={Loading}
                            ratingImages={ratingImages}
                            totalImages={totalImages}
                        />

                                                 {/* Related Products */}
                         {similarProducts?.length > 0 && (
                             <div className="related-products-section">
                                 <h2 className="section-title">{t("related_product")}</h2>
                                 <div className="related-products-grid">
                                     <Swiper
                                         spaceBetween={20}
                                         slidesPerView={1}
                                                breakpoints={{
                                             640: { slidesPerView: 2 },
                                             768: { slidesPerView: 3 },
                                             1024: { slidesPerView: 4 },
                                             1280: { slidesPerView: 5 }
                                         }}
                                                navigation={true}
                                         modules={[Navigation]}
                                         className="related-products-swiper"
                                         autoplay={{
                                             delay: 3000,
                                             disableOnInteraction: false,
                                         }}
                                     >
                                         {similarProducts.map((relatedProduct) => (
                                             <SwiperSlide key={relatedProduct.id}>
                                                 <ProductCard product={relatedProduct} />
                                                        </SwiperSlide>
                                                ))}
                                            </Swiper>
                                        </div>
                                </div>
                         )}
                    </div>
                </div>
            ) : (
                <div className="no-internet-container">
                    <MdSignalWifiConnectedNoInternet0 />
                    <p>{t("no_internet_connection")}</p>
                </div>
            )}
        </>
    );
};

export default ProductDetails;

/*
 * التحديثات المضافة:
 * 
 * 1. تعديل قراءة صور متغيرات المنتج بناءً على الألوان
 * 2. دعم البنية الجديدة للصور: { "#1e4ba4": ["url1", "url2"], "#000000": ["url3"] }
 * 3. إضافة دالة hasColorImages للتحقق من وجود صور للون معين
 * 4. تحديث getCurrentVariantImages لتعرض صور اللون المحدد
 * 5. تحديث getVariantImages لتعامل مع البنية الجديدة
 * 6. إضافة مؤشر بصري للألوان التي تحتوي على صور
 * 7. تحسين تجربة المستخدم عند تغيير الألوان
 * 8. عرض الصورة الرئيسية فقط إذا كان اللون غير موجود في images
 * 
 * البنية الجديدة للصور:
 * - كل لون يحتوي على مصفوفة من الصور الخاصة به
 * - عند اختيار لون له صور خاصة، يتم عرض جميع صور هذا اللون
 * - عند اختيار لون ليس له صور خاصة، يتم عرض الصورة الرئيسية فقط
 * - عند عدم اختيار لون، يتم عرض جميع صور المتغير
 */
